import React from 'react';
import PropTypes from 'prop-types';

export default function FirstName({
  Field, Err, useInput, errors, focus,
}) {
  const fieldRef = React.useRef();

  React.useEffect(() => {
    if (focus) {
      fieldRef.current.focus();
    }
  }, [focus]);

  return (
    <React.Fragment>
      <Field ref={fieldRef} type="text" placeholder="first name" {...useInput('firstName', 'isRequired')} />
      {!!errors.firstName && <Err>First name is required</Err>}
    </React.Fragment>
  );
}

FirstName.propTypes = {
  Field: PropTypes.elementType.isRequired,
  Err: PropTypes.elementType.isRequired,
  useInput: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    firstName: PropTypes.string,
  }),
  focus: PropTypes.bool,
};

FirstName.defaultProps = {
  errors: { firstName: null },
  focus: false,
};
